/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { useTheme } from '@providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { UsersListComp, Header, NewUserModal } from '../components';
import { vappContainer } from '@/application';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import {
  useSMActivateUser,
  useSMInviteUser,
  useSMDeleteUser,
  useSMReInviteUser,
  useSMSuspendUser,
  useSMUsersListPageGetContent,
} from '@pages/AdminPage/machines';
import { AdminPageService } from '@pages/AdminPage/services';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';

const getSrv = () => {
  return vappContainer.get<AdminPageService>(AdminPageService.displayName);
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const srv = getSrv();

  useEffect(() => {
    //srv?.resetCriteria();
  }, []);

  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});

  const { inviteUserMachine, inviteUserSend, inviteUserState } =
    useSMInviteUser({});

  const { deleteUserMachine, deleteUserSend, deleteUserState } =
    useSMDeleteUser({});

  const { suspendUserMachine, suspendUserSend, suspendUserState } =
    useSMSuspendUser({});

  const { reInviteUserMachine, reInviteUserSend, reInviteUserState } =
    useSMReInviteUser({});

  const { activateUserMachine, activateUserSend, activateUserState } =
    useSMActivateUser({});
  console.log('render page', usersListPageState?.event?.data?.value);

  const _onHeaderDDActionItemClick = (id: string) => {};
  const onAddUser = (id: string) => {
    if (!showModal) {
      setShowModal(true);
    }
  };
  const onError = () => {
    //window.location.reload(false);
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onModalClose = () => {
    if (showModal) {
      setShowModal(false);
    }
  };
  const onAddNewUser = (data: any) => {
    console.log(`profile data`, data);
    if (showModal) {
      setShowModal(false);
    }
    inviteUserSend('START', {
      payload: data,
    });
  };

  const onHeaderAction2Click = (id: string) => {
    if (id) {
      switch (id) {
        case 'import_users':
          toast.success('Coming soon!');
          // history.push(
          //   `${routesConfig?.routes?.UsersBatch?.path}`
          // );
          break;
        default:
          console.log(`unsupported header button id ${id} clicked`);
      }
    }
  };

  // const onAddNewUser = (
  //   email: string,
  //   firstName: string,
  //   lastName: string,
  //   invite: boolean
  // ) => {
  //   console.log(`on add new user `, email, firstName, lastName, invite);
  //   inviteUserSend("START", {
  //     payload: {
  //       email: email,
  //       firstName: firstName,
  //       lastName: lastName,
  //       invite: invite,
  //     },
  //   });
  // };

  const _addNewUser = () => {
    if (showModal) {
      return (
        // <NewUserModal
        //   showModal={showModal}
        //   onAcknowledgement={onAddNewUser}
        //   onDeny={onModalClose}
        // />
        <TweetyModal
          show={true}
          //size={"md"}
          scrollable={false}
          backdrop={'static'}
          submitButtonTitle={'Invite'}
          onSubmit={onAddNewUser}
          onHide={() => setShowModal(false)}
          title={'Add New Admin User'}
          tweetyWidgetProps={{
            fields: srv?.agent?.getStaticUserPageSync()?.newUser?.FIELDS,
            layout: srv?.agent?.getStaticUserPageSync()?.newUser?.layout,
          }}
        />
      );
    }
  };

  const onRefresh = () => {
    usersListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    // srv?.resetCriteria();
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const deleteUser = (id: any) => {
    deleteUserSend('START', {
      payload: id,
    });
    //toast.success("Coming soon!")
  };

  const onSuspendUsers = (ids: any) => {
    suspendUserSend('START', {
      payload: ids,
    });
  };
  const onInviteUsers = (ids: any) => {
    inviteUserSend('START', {
      payload: ids,
    });
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria =
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((item: any) => {
        return {
          column: item?.filters?.inputData?.id,
          op: item?.filters?.inputData?.label,
          value: [item?.filters[item?.filters?.inputData?.label]],
        };
      });
    usersListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onTogglePress = (key: string, email: string) => {
    if (key === 'suspend') {
      suspendUserSend('START', {
        payload: email,
      });
    }
    if (key === 're-invite') {
      reInviteUserSend('START', {
        payload: email,
      });
    }
    if (key === 'activate') {
      activateUserSend('START', {
        payload: email,
      });
    }
  };

  const _renderNotifications = () => {
    if (inviteUserState?.matches('INVITE_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticUserPageSync()?.notifications
            ?.userInviteSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (activateUserState?.matches('ACTIVATE_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getActivateUserSync()?.notifications
            ?.activateUserSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (deleteUserState?.matches('DELETE_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticUserPageSync()?.notifications
            ?.deleteUserSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (suspendUserState?.matches('SUSPEND_USER_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticUserPageSync()?.notifications
            ?.suspendUserSuccess || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (reInviteUserState?.matches('RE_INVITE_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getStaticUserPageSync()?.notifications
            ?.reInviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }

    return null;
  };

  const _renderUserList = () => {
    //console.log("renderpage",usersListPageState?.event?.data?.value);
    if (
      inviteUserState?.matches('INVITE_USER') ||
      reInviteUserState?.matches('RE_INVITE')
    ) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingUserSync()?.loading?.inviteUser || {})}
        />
      );
    }
    if (
      suspendUserState?.matches('SUSPEND_USER') ||
      activateUserState?.matches('ACTIVATE_USER')
    ) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingUserSync().loading?.suspendUser || {})}
        />
      );
    }

    if (deleteUserState?.matches('DELETE_USER')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingUserSync()?.loading?.deleteUser || {})}
        />
      );
    }

    if (usersListPageState?.matches('RENDER_ADMIN_USER')) {
      return (
        <>
          {usersListPageState?.event?.data?.value?.isEmpty ? (
            <StateOSD
              {...(srv?.agent?.getLoadingUserSync()?.loading?.usersEmpty || {})}
            />
          ) : (
            <UsersListComp
              {...(usersListPageState?.event?.data?.value || {})}
              deleteItems={deleteUser}
              suspendItems={onSuspendUsers}
              inviteUsers={onInviteUsers}
              onTogglePress={onTogglePress}
              onViewClick={props?.onViewDetailClick}
              onRowClick={props?.onViewDetailClick}
            />
          )}
        </>
      );
    }
    if (usersListPageState?.matches('GET_ADMIN_USER')) {
      return (
        <StateOSD
          {...(srv?.agent?.getLoadingUserSync()?.loading?.loadingUsers || {})}
        />
      );
    }
    return null;
  };

  const _renderHeader = () => {
    if (srv?.agent?.getHeaderUserSync()?.header) {
      return (
        <>
          <Header
            {...(srv?.agent?.getHeaderUserSync()?.header || {})}
            onHeaderAction1Click={onAddUser}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onHeaderAction2Click={onHeaderAction2Click}
            onRefreshClick={onRefresh}
          />
          <SearchFilter
            {...(srv?.agent?.getHeaderUserSync()?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    usersListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(usersListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_ADMIN_USER_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (inviteUserState?.matches('INVITE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.inviteUser || {})}
          description={[
            inviteUserState?.event?.data?.value,
            srv?.agent?.getErrorContentSync()?.error?.inviteUser
              ?.description[1],
          ]}
          onAcknowledgement={onError}
          onDeny={onError}
        />
      );
    }
    if (deleteUserState?.matches('DELETE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.deleteUser || {})}
          description={[
            deleteUserState?.event?.data?.value,
            srv?.agent?.getErrorContentSync()?.error?.deleteUser
              ?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (suspendUserState?.matches('SUSPEND_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.suspendUser || {})}
          description={[
            suspendUserState?.event?.data?.value,
            srv?.agent?.getErrorContentSync()?.error?.suspendUser
              ?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (activateUserState?.matches('ACTIVATE_USER_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.activateUser || {})}
          description={[
            activateUserState?.event?.data?.value,
            srv?.agent?.getErrorContentSync()?.error?.activateUser
              ?.description[1],
          ]}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
    if (reInviteUserState?.matches('RE_INVITE_FAILED')) {
      return (
        <NotificationModal
          showModal={true}
          {...(srv?.agent?.getErrorContentSync()?.error?.reinviteUser || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderPage = () => {
    return (
      <>
        {_renderHeader()}
        {_renderUserList()}
        {_renderPagination()}
        {_renderErrorModals()}
        {_addNewUser()}
        {_renderNotifications()}
      </>
    );
  };
  return <>{_renderPage()}</>;
};
